export const RELEASES = 'releases';

export const RELEASE_KEYS = {
    "2026": "2026",
    "sukkot": "sukkot",
}